//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadGroupsProductsService() {
  try {
    const response = await api.get("/grupos-produtos")
    return response;
  } catch (error) {
    toast.error("Erro ao carregar produtos!");
    return null;
  }
}